import AllTimeReports from "../models/finance/AllTimeReports";
import ReportDTO from "../models/finance/Reports";
import ReportRequest from "../models/request/ReportRequest";
import { ALL_TIME_REPORTS_ENDPOINT, REPORTS_ENDPOINT } from "../utils/constants/ApiConstants";
import { formatBackendDate } from "../utils/DateUtil";
import { httpClient } from "./http/httpClient";
import { } from "./schemas";

export async function getAllTimeReports(): Promise<AllTimeReports> {
  const { data } = await httpClient.get<AllTimeReports>(ALL_TIME_REPORTS_ENDPOINT, { authenticated: true });
  return data;
}

export async function getMonthlyReport(startDate: Date, endDate: Date): Promise<ReportDTO> {
  const body: ReportRequest = {
    startDate: formatBackendDate(startDate),
    endDate: formatBackendDate(endDate),
  };
  const { data } = await httpClient.post<ReportDTO, ReportRequest>(REPORTS_ENDPOINT, body, { authenticated: true });
  return data;
}


